import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SelectItem } from '@web/shared/ui';
import { QuantityUnit } from '../enums/quantity-unit';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class QuantityUnitProviderService {
  private readonly entries = new Map<QuantityUnit, string>([
    [QuantityUnit.Piece, 'Sztuka'],
    [QuantityUnit.Collection, 'Zestaw'],
    [QuantityUnit.Package, 'Opakowanie'],
    [QuantityUnit.Pair, 'Para'],
    [QuantityUnit.Sachet, 'Saszetka'],
  ]);

  public label(unit: QuantityUnit): Observable<string> {
    const entry = this.entries.get(unit);

    if (isNil(entry)) {
      throw new EntryNotFoundException(`The entry for "${unit}" not found.`);
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<QuantityUnit>[]> {
    const result = Array.from(this.entries.entries()).map(
      ([status, label]) => new SelectItem(label, status),
    );

    return of(result);
  }
}
